import { useContext } from 'react';
import { LocaleContext } from 'softcat:contexts/locale.tsx';

export const useLocale = () => {
    const localeContext = useContext(LocaleContext);

    if (!localeContext) {
        throw new Error('LocaleContext has to be used within <LocaleProvider>');
    }

    return localeContext;
};
